import React from 'react';

import { Tag } from '@chakra-ui/react';
import { themeColors } from 'themes/clients/baseTheme';

export default function CustomTagWithoutLabel({ tag = {} }) {
  return (
    <Tag
      size="md"
      borderRadius="6px"
      py="8px"
      variant="solid"
      backgroundColor={themeColors.neutral.F2F2F2}
      color={themeColors.text.g1}
      fontWeight={400}
      fontSize="14px"
      padding="0 4px 0 4px"
      wordBreak="break-all"
      boxShadow="0px 0px 1px 0px rgba(0, 0, 0, 0.25)"
    >
      {tag?.tagName}
    </Tag>
  );
}
